import DoubleBookModal from '~/components/fragments/dialogs/double-book.vue';

// Opens the "double book" modal when an add is blocked by a schedule overlap.
// The overlap decision is made server-side (POST /api/v1/schedule/add returns a
// { conflict } instead of adding); this just presents it.
export const useDoubleBook = () => {
    const { open } = useModal();

    const show = (newSession, conflict) => {
        open(DoubleBookModal, { newSession, conflict });
    };

    return { show };
};
